import { useScrollOffsets } from '@/hooks/element-hooks'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { NavItem } from '@/components/NavItem'
import { links } from '@/utils/link'
import {
  SplitViewHeader,
  SplitViewHeaderTitle,
} from '@/components/SplitView/SplitViewHeader'
import { ScrollView } from '@/components/ScrollView'

export interface AdminNavProps {
  canManageJobScopeChangeRequest: boolean
  scopeChangeRequestsCount: number
  canManageBookkeeping: boolean
  bookkeepingManagerTotal?: number
  canSeeStaffingManager: boolean
  canManageServices: boolean
  canSeePayouts: boolean
  canManageAccountMergeRequests: boolean
}

export function AdminNav({
  canManageJobScopeChangeRequest,
  scopeChangeRequestsCount,
  canManageBookkeeping,
  bookkeepingManagerTotal,
  canSeeStaffingManager,
  canManageServices,
  canSeePayouts,
  canManageAccountMergeRequests,
}: AdminNavProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <Sandwich stretch>
      <SandwichBun>
        <SplitViewHeader compact scrollOffset={scrollOffset}>
          <SplitViewHeaderTitle>Admin</SplitViewHeaderTitle>
        </SplitViewHeader>
      </SandwichBun>
      <SandwichContent>
        <ScrollView ref={scrollRef}>
          {canManageJobScopeChangeRequest && (
            <NavItem
              to={links.adminChangeRequests()}
              title={`Change requests (${scopeChangeRequestsCount})`}
            >
              Approve or reject job updates
            </NavItem>
          )}

          {canManageBookkeeping && (
            <NavItem
              to={links.adminBookkeepingManager()}
              title={`Bookkeeping manager (${bookkeepingManagerTotal})`}
            >
              Manage bookkeeping access & assesments
            </NavItem>
          )}
          {canSeeStaffingManager && (
            <NavItem to={links.adminStaffingManager()} title="Staffing manager">
              Manage and post workspace opportunities
            </NavItem>
          )}
          {canManageServices && (
            <NavItem to={links.adminBundleManager()} title="Bundle manager">
              Package service items as bundles
            </NavItem>
          )}
          {canManageServices && (
            <NavItem to={links.adminServiceManager()} title="Service manager">
              Manage work items related to the platform
            </NavItem>
          )}
          {canSeePayouts && (
            <NavItem to={links.adminPayouts()} title="Payouts">
              Review the next payouts and view past ones
            </NavItem>
          )}
          {canManageAccountMergeRequests && (
            <NavItem
              to={links.adminAccountMergeRequests()}
              title="Merge requests"
            >
              Review account merge requests
            </NavItem>
          )}
        </ScrollView>
      </SandwichContent>
    </Sandwich>
  )
}
